<div class="d-flex justify-content-center">
  <p-toast key="error" />
  <p-toast key="success" (onClose)="router.navigate(['login'])" />
  <p-card class="col-md-4" header="Register for Online Access">
    <form [formGroup]="registerForm" (ngSubmit)="register()">
      <p-floatlabel variant="on">
        <input
          pInputText
          id="firstName"
          pSize="small"
          formControlName="firstName"
        />
        <label htmlFor="firstName">First Name</label>
      </p-floatlabel>
      @if (isControlInvalid("firstName")) {
        <small class="p-error px-2">First Name is required.</small>
      }
      <p-floatlabel variant="on" class="input-space">
        <input
          pInputText
          id="lastName"
          pSize="small"
          formControlName="lastName"
        />
        <label htmlFor="lastName">Last Name</label>
      </p-floatlabel>
      @if (isControlInvalid("lastName")) {
        <small class="p-error px-2">Last Name is required.</small>
      }
      <p-floatlabel variant="on" class="input-space">
        <input
          pInputText
          id="company"
          pSize="small"
          formControlName="company"
        />
        <label htmlFor="company">Company</label>
      </p-floatlabel>
      @if (isControlInvalid("company")) {
        <small class="p-error px-2">Company is required.</small>
      }
      <p-floatlabel variant="on">
        <input pInputText id="city" pSize="small" formControlName="city" />
        <label htmlFor="city">City</label>
      </p-floatlabel>
      @if (isControlInvalid("city")) {
        <small class="p-error px-2">City is required.</small>
      }
      <p-floatlabel variant="on">
        <p-select
          id="stateId"
          inputId="state"
          name="state"
          formControlName="stateId"
          [style]="{ width: '100%' }"
          optionLabel="name"
          optionValue="id"
          filterMatchMode="startsWith"
          [options]="statesList"
          [required]="true"
          size="small"
        >
        </p-select>
        <label htmlFor="state">State</label>
      </p-floatlabel>
      @if (isControlInvalid("stateId")) {
        <small class="p-error px-2">State is required.</small>
      }
      <p-floatlabel variant="on">
        <p-inputMask
          inputId="phone"
          name="phone"
          formControlName="phone"
          [required]="true"
          [style]="{ width: '100%' }"
          mask="(999) 999-9999"
          size="small"
        />
        <label htmlFor="phone">Phone Number</label>
      </p-floatlabel>
      @if (isControlInvalid("phone")) {
        <small class="p-error px-2">Phone Number is required.</small>
      }
      <p-floatlabel variant="on">
        <input
          pInputText
          id="email"
          type="email"
          pSize="small"
          formControlName="email"
        />
        <label htmlFor="email">Email</label>
      </p-floatlabel>
      @if (isControlInvalid("email")) {
        <small class="p-error px-2">Email is required.</small>
      }
      <div
        class="col-12 mt-3"
        [ngClass]="{
          'is-invalid': submitted && !captchaIsValid,
        }"
      >
        <re-captcha
          class="form-control mb-2 fs-6"
          class="mb-2 fs-6"
          (resolved)="getCaptchaValue($event)"
          siteKey="{{ captchaKey }}"
        ></re-captcha>
        @if (submitted && !captchaIsValid) {
          <p class="text-danger px-2">
            Please validate you are not a robot before submitting.
          </p>
        }
      </div>
      <p-button type="submit" size="small" class="mt-4">Submit</p-button>
    </form>
  </p-card>
</div>
